// View as: InRange staff reading the Amazon overview as someone on its share list, to check
// in production what they see (docs/Y2026-Q4/design-amazon-item-owners.md section 2.8). Kept
// for the tab only; every request names the person, and the server answers as for them and
// refuses every write.

export const VIEW_AS_HEADER = "X-View-As";

const KEY = "inrange-agents.view-as";

export interface ViewAs {
  email: string;
  name: string;
}

/** The person this tab views as, or null. Unreadable storage reads as none. */
export const viewingAs = (): ViewAs | null => {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ViewAs;
    return parsed.email ? parsed : null;
  } catch {
    return null;
  }
};

/** Reload the page as ``person`` sees it. */
export const startViewAs = (person: ViewAs, path: string): void => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(person));
  } catch {
    return;
  }
  window.location.assign(path);
};

/** Forget it without reloading: on signing out, and for anyone not signed in as staff, so
 * the next person at this tab is never sent as someone else. */
export const forgetViewAs = (): void => {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing was kept either.
  }
};

export const exitViewAs = (): void => {
  forgetViewAs();
  window.location.reload();
};
